// 취소·환불·교환 정책. 정육(신선식품) 특성상 단순변심 청약철회를 제한하되, 하자/오배송/매장귀책은 보호한다.
// 전자상거래법 제17조 제2항(청약철회 제한 사유 사전 고지) 근거. 시스템 동작(수락 전 취소/카드 자동환불)과 일치시킨다.

import LegalPageShell, { LegalSection } from "@/shared/LegalPageShell.tsx";
import { BUSINESS_INFO } from "@/shared/businessInfo.ts";

// 취소·환불·교환 정책 페이지(신선식품 변심환불 제한 + 하자/오배송 보호).
export default function RefundPage() {
  return (
    <LegalPageShell title="취소·환불·교환 정책" updatedAt="2026-06-22">
      <LegalSection heading="1. 주문 취소">
        <p>
          주문 수락(접수) 전에는 앱에서 직접 주문을 취소할 수 있으며, 카드로 결제 예정이던 금액은 청구되지
          않거나 청구된 경우 전액 환불됩니다.
        </p>
        <p>
          매장이 주문을 수락한 이후에는 상품 준비가 시작되므로 앱에서 직접 취소가 어렵습니다. 이 경우 아래
          고객센터로 연락해 주시면 상황에 따라 처리해 드립니다.
        </p>
      </LegalSection>

      <LegalSection heading="2. 청약철회(단순 변심) 제한">
        <p>
          본 매장의 상품은 정육 등 신선·냉장 식품으로, 수령(배송 완료 또는 매장 수령) 이후에는 상품의 특성상
          재판매가 불가능합니다. 따라서 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제2항에 따라
          수령 후 단순 변심에 의한 청약철회(환불·교환)는 제한됩니다. 이 점은 주문 시 안내됩니다.
        </p>
      </LegalSection>

      <LegalSection heading="3. 교환·환불이 가능한 경우">
        <p>다음의 경우에는 교환 또는 전액 환불해 드립니다.</p>
        <p>- 상품에 하자가 있거나 변질·손상된 경우</p>
        <p>- 주문한 상품과 다른 상품이 배송·제공된 경우(오배송)</p>
        <p>- 매장의 귀책 사유로 정상적인 상품을 받지 못한 경우</p>
        <p>
          위 사유는 수령 후 가급적 빠른 시간 내(상품 특성상 당일 권장)에 사진 등과 함께 고객센터로 알려
          주시면 신속히 처리해 드립니다.
        </p>
      </LegalSection>

      <LegalSection heading="4. 환불 방법 및 시기">
        <p>
          카드로 결제한 주문의 환불은 결제 취소(승인 취소) 방식으로 처리되며, 카드사 사정에 따라 영업일
          기준 3~7일 정도 소요될 수 있습니다.
        </p>
        <p>현장 결제(매장 수령 시 결제) 주문은 결제 전 취소 시 청구 자체가 발생하지 않습니다.</p>
      </LegalSection>

      <LegalSection heading="5. 문의">
        <p>
          취소·환불·교환 문의: {BUSINESS_INFO.tel} / {BUSINESS_INFO.email}
        </p>
      </LegalSection>
    </LegalPageShell>
  );
}
